<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>{{ isEdit ? 'Edit' : 'Add' }} Allergen</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div class="v-table__overflow" v-else>
      <table class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th role="columnheader" scope="col" class="column text-xs-left" style="width: 65px">Language</th>
            <th role="columnheader" scope="col" class="column text-xs-left">Name</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in allergens.names" :key="index">
            <td style="width: 65px">{{item.language}}</td>
            <td>
              <v-text-field
                type="text"
                :value="item.name"
                v-model="item.name" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <v-layout justify-end align-center>
      <div class="text-xs-center" v-if="languages.length > 0">
        <v-menu>
          <v-btn
            flat
            outline
            slot="activator"
            type="button">
            Add language
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(lang, index) in languages"
              :key="index"
              v-if="lang !== language"
              @click="addLang(lang.value, index)">
              <v-list-tile-title>
                {{lang.text}}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <v-btn color="primary" @click="submit()">Submit</v-btn>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    props: ['edit', 'maxAllergenId'],
    data() {
      return {
        err: '',
        language: this.$cookie.get('lang') || 'en',
        languages: JSON.parse(localStorage.languages),
        allergens: {
          names: [
            {
              language: this.$cookie.get('lang') || 'en',
              name: '',
            },
          ],
        },
        isEdit: false,
      };
    },
    methods: {
      addLang(lang, langIndex) {
        this.allergens.names.push({
          language: lang,
          name: '',
        });
        this.languages.splice(langIndex, 1);
      },
      submit() {
        const allergen = {};
        if(!this.isEdit){
          allergen['allergenId'] = this.maxAllergenId+1;
        }else{
          allergen['allergenId'] = this.edit.allergen.allergenId;
        }
        allergen.name = {};
        this.allergens.names.forEach((entry) => {
          if (entry.name !== '') {
            allergen.name[entry.language] = entry.name;
          }
        });
        if (this.isEdit) {
          const index = this.edit.index;
          this.$emit('update', {
            allergen,
            index,
          });
        } else {
          this.$emit('submit', allergen);
        }
        this.$emit('close');
      },
    },
    created() {
      if (this.edit) {
        this.isEdit = true;
        const allergen = this.edit.allergen;
        const languages = Object.keys(allergen.name);
        this.allergens.names = [];
        languages.forEach((language) => {
          let index = null;
          this.allergens.names.push({
            language,
            name: allergen.name[language],
          });
          this.languages.forEach((lang, i) => {
            if (lang.value === language) {
              index = i;
            }
          });
          if (index !== null) {
            this.languages.splice(index, 1);
          }
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .err {
    font-size: 16px;
    padding: 15px;
    padding-top: 0;
  }
  .modal {
    display: block;
    background: rgba(0, 0, 0, 0.5);

    &-body {
      max-height: 80vh;
      overflow-y: auto;
    }
  }
  @media (min-width: 576px) {
    .modal-dialog {
        max-width: 70%;
    }
  }

</style>



// WEBPACK FOOTER //
// AllergensModal.vue?41826113